/**
 * Initialises an event bus helper
 */
const initEventBus = (): void => {
  if (!window['blubolt']) return;

  window['blubolt'].eventBus = [];
}

/**
 * Adds a custom event listener. This works similar to the native event listeners with the exception that they are not
 * directly attached to an element / window. These events are also synchronous.
 *
 * @param event 
 * @param callback 
 */
const addEvent = (event: string, callback: (data?: any) => void): void => {
  if (!window['blubolt'] || !window['blubolt'].eventBus) return;

  window['blubolt'].eventBus[event] = callback;
}

/**
 * Triggers a custom event listener.
 *
 * @param event 
 * @param data 
 */
const triggerEventListener = (event: string, data?: Record<string, any>): void => {
  if (!window['blubolt'] || !window['blubolt'].eventBus[event]) return;

  try {
    window['blubolt'].eventBus[event](data);
  } catch (e) {
    console.error(e);
  }
}

export {
  initEventBus,
  addEvent,
  triggerEventListener
}